import React, { FC } from 'react';
import Image from 'components/Image/Image';
import noResultImg from 'assets/images/noResult.svg';
import noResultDarkImg from 'assets/images/noResult-dark.svg';
import { Text } from 'components/Typography';
import { useAppSelector } from 'redux/store';
import SNoResaltWrapper from './NoResult.style';

export type TNoResult = {
  noResult?: boolean;
  text?: string;
  img?: string;
};
export const NoResult: FC<TNoResult> = ({
  noResult,
  text = 'No Results found',
  img,
}) => {
  /* The illustration is an <img>, so it can't take the theme through
     currentColor the way the nav icons do — each mode gets its own file and the
     right one is picked here. A caller that passes `img` keeps full control. */
  const theme = useAppSelector(state => state.appSettings.theme);
  if (!noResult) return null;
  return (
    <SNoResaltWrapper>
      <Image
        src={img || (theme === 'dark' ? noResultDarkImg : noResultImg)}
        alt="no result"
        width={260}
      />
      <Text fontlevel={4} fontWeight={500} className="mt-4 no-result">
        {text}
      </Text>
    </SNoResaltWrapper>
  );
};
